import './Banner-d9f6e355.css';

var classes = {"Banner":"prc-Banner-Banner-IR8eJ","BannerContainer":"prc-Banner-BannerContainer-lbx3d","BannerContent":"prc-Banner-BannerContent-zTITK","BannerTitle":"prc-Banner-BannerTitle-TcuJl","BannerIcon":"prc-Banner-BannerIcon-WuOyf","BannerDismiss":"prc-Banner-BannerDismiss-uBZVm","BannerActionsContainer":"prc-Banner-BannerActionsContainer-ukGMH","BannerActions":"prc-Banner-BannerActions-XCfHL"};

export { classes as default };
